type ErrorNoticeProps = {
  message: string;
  onRetry?: () => void;
};

/**
 * 利用者向けエラー表示
 *
 * @param props.message - エラーメッセージ
 * @param props.onRetry - 再試行処理
 * @returns エラー表示
 */
export const ErrorNotice = ({ message, onRetry }: ErrorNoticeProps) => {
  return (
    <div className="notice notice--error" role="alert">
      <span aria-hidden="true">!</span>
      <p>{message}</p>
      {onRetry ? (
        <button className="text-button" type="button" onClick={onRetry}>
          もう一度試す
        </button>
      ) : null}
    </div>
  );
};

type EmptyStateProps = {
  title: string;
  description: string;
};

/**
 * 空状態の案内
 *
 * @param props.title - 見出し
 * @param props.description - 説明
 * @returns 空状態表示
 */
export const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <div className="empty-state">
      <div className="empty-state__mark" aria-hidden="true">
        ○
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

type LoadingViewProps = {
  label?: string;
};

/**
 * 読み込み中表示
 *
 * @param props.label - 読み上げ文言
 * @returns 読み込み中表示
 */
export const LoadingView = ({ label = "読み込んでいます" }: LoadingViewProps) => {
  return (
    <div className="loading-view" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
};
